import { REPORT_ERROR, ADD_REPORT } from "../actions/types";

const initialState = {
  reports: [],
  report: null,
  loading: true,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_REPORT:
      return {
        ...state,
        report: payload,
        reports: [],
        loading: false,
      };
    case REPORT_ERROR:
      return {
        ...state,
        report: null,
        reports: [],
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
